/**
 * Iguana Labs Theme - Main JavaScript
 * Core theme functionality
 */

(function() {
  'use strict';

  // Theme namespace
  window.theme = window.theme || {};

  /**
   * Utility Functions
   */
  theme.utils = {
    debounce: function(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },

    throttle: function(func, limit) {
      let inThrottle;
      return function() {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => inThrottle = false, limit);
        }
      };
    }
  };

  /**
   * Smooth Scroll
   */
  theme.smoothScroll = function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  /**
   * Scroll Animations
   */
  theme.scrollAnimations = function() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-scroll-animation]').forEach(el => {
      observer.observe(el);
    });
  };

  /**
   * Header Scroll Behavior
   */
  theme.headerScroll = function() {
    const header = document.querySelector('.header');
    if (!header) return;

    let lastScroll = 0;

    window.addEventListener('scroll', theme.utils.throttle(() => {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScroll = currentScroll;
    }, 100));
  };

  /**
   * Initialize theme
   */
  theme.init = function() {
    theme.smoothScroll();
    theme.headerScroll();
    
    // Initialize scroll animations if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
      theme.scrollAnimations();
    }


  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', theme.init);
  } else {
    theme.init();
  }

})();

